import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {emergencies} from '../../constDatas/constDatas'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const Emergency = ({value, setValue, hasAll = true, error, label="Priority", isDisabled = false}) => {
    const isAll = hasAll && value?.includes(-1)
    const [checked, setChecked] = useState(isAll)
    const [disabled, setDisabled] = useState(isAll)

    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

    useEffect(() => {
        if (refreshClicked) {
            setChecked(isAll)
            setDisabled(isAll)
        }
    }, [refreshClicked])

    const handleCheckChange = (event) => {
        const isChecked = event.target.checked
        setChecked(isChecked)
        setDisabled(isChecked)
        if (isChecked) {
            setValue([-1])
        } else {
            setValue([])
        }
    }

    const handleChange = (event) => {
        const selectedStatus = event.target.value
        setValue(selectedStatus)
        setChecked(selectedStatus.includes(-1))
    }

    return (
        <>
            {hasAll ? (
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <FormControl fullWidth size="small">
                            <InputLabel>{label}</InputLabel>
                            <Select
                                multiple
                                disabled={disabled}
                                value={value || []}
                                onChange={handleChange}
                                input={<OutlinedInput label={label} />}
                                MenuProps={MenuProps}
                                sx={
                                    disabled && {
                                        backgroundColor: 'hsl(0, 0%, 95%)',
                                    }
                                }
                                renderValue={(selected) => {
                                    if (selected.includes(-1)) {
                                        return 'All'
                                    }
                                    return selected.map((x) => emergencies.find((y) => y.value === x)?.label).join(', ')
                                }}
                            >
                                {emergencies.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                        <Checkbox checked={value?.includes(item.value)}/>
                                        <ListItemText
                                            primary={
                                                <Box display="flex" gap={1} alignItems="center">
                                                    <Box display="inlineBlock" sx={{minWidth: '50px'}}>
                                                        {item.label}
                                                    </Box>
                                                    {item.icon}
                                                </Box>
                                            }
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckChange}/>}
                                              label="All"/>
                        </FormGroup>
                    </Grid>
                </Grid>
            ) : (
                <FormControl size="small" fullWidth>
                    <InputLabel>{label}</InputLabel>
                    <Select
                        disabled={isDisabled}
                        sx={
                            isDisabled && {
                                backgroundColor: 'hsl(0, 0%, 95%)',
                            }
                        }
                        label={label}
                        value={value || ''}
                        error={Boolean(error)}
                        onChange={(event) => {
                            setValue(event.target.value)
                        }}
                    >
                        <MenuItem value={''}>None</MenuItem>
                        {emergencies.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                <Box display="flex" gap={1} alignItems="center">
                                    <Box display="inlineBlock" sx={{minWidth: '50px'}}>
                                        {item.label}
                                    </Box>
                                    {item.icon}
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <FormHelperText sx={{color: '#d32f2f', ml: 0}}>
                            {error.message || 'This field is required'}
                        </FormHelperText>
                    )}
                </FormControl>
            )}
        </>
    )
}

export default Emergency
